import SalidasAgrupadasPage from './SalidasAgrupadasPage'
export default function HistorialPage() {
  return <SalidasAgrupadasPage titulo="Historial de envíos" />
}
